import { ProjectsGuard } from './projects.guard';
import { VersionsGuard } from './versions.guard';
import { ResultGuard } from './result.guard';
import { CreditsGuard } from './credits.guard';
import { InvitationGuard } from './invitation.guard';
import { CompareGuard } from './compare.guard';
import { ViewerGuard } from './viewer.guard';

export const guards: any[] = [
  ProjectsGuard,
  VersionsGuard,
  ResultGuard,
  CreditsGuard,
  InvitationGuard,
  CompareGuard,
  ViewerGuard,
];

export * from './projects.guard';
export * from './versions.guard';
export * from './result.guard';
export * from './credits.guard';
export * from './invitation.guard';
export * from './compare.guard';
export * from './viewer.guard';
